import {
  ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS,
  normalizeRenderConfig,
  sortReportRows,
} from "./renderConfig";
import { buildCsv } from "./agentServiceTimeExport";

const SUMMARY_HEADERS = Object.freeze(["Scope", "Total Visitors", "Average", "Min", "Max"]);
const BREAKDOWN_HEADERS = Object.freeze(["Scope", "Period", "Visitors"]);

const toPrimitiveNumber = (value) => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : 0;
};

const getPointPeriod = (point) => point.date ?? point.day ?? point.name ?? point.hour ?? "";

export const getArrivalRatesSummaryRows = (scopes = [], renderConfig) => {
  const config = normalizeRenderConfig(renderConfig, {
    columnDefinitions: ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS,
  });
  return sortReportRows(
    scopes.map((scope) => ({
      ...scope,
      scopeName: scope.scopeName || scope.branchName || "Entire Organization",
    })),
    config,
    { columnDefinitions: ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS }
  );
};

export const getArrivalRatesSummaryCsvRows = (scopes = [], renderConfig) =>
  getArrivalRatesSummaryRows(scopes, renderConfig).map((row) => [
    row.scopeName,
    toPrimitiveNumber(row.total),
    toPrimitiveNumber(row.average),
    toPrimitiveNumber(row.min),
    toPrimitiveNumber(row.max),
  ]);

export const getArrivalRatesBreakdownCsvRows = (scopes = [], renderConfig) =>
  getArrivalRatesSummaryRows(scopes, renderConfig).flatMap((row) =>
    (row.chart || []).map((point) => [
      row.scopeName,
      getPointPeriod(point),
      toPrimitiveNumber(point.total ?? point.value ?? point.count),
    ])
  );

const triggerCsvDownload = (filename, csv) => {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

export const downloadArrivalRatesSummaryCsvFiles = ({ scopes, renderConfig, filenamePrefix }) => {
  triggerCsvDownload(
    `${filenamePrefix}_summary.csv`,
    buildCsv(SUMMARY_HEADERS, getArrivalRatesSummaryCsvRows(scopes, renderConfig))
  );
  triggerCsvDownload(
    `${filenamePrefix}_breakdown.csv`,
    buildCsv(BREAKDOWN_HEADERS, getArrivalRatesBreakdownCsvRows(scopes, renderConfig))
  );
};
